module.exports = __webpack_public_path__ + "img/lala_scroll05.5fb7f950.webp";